import {
  useSurveyStore,
  selectActiveQuestion
} from "views/landlord-surveys-id/store";
import { SidebarQuestions } from "../sidebar-questions";
import { Card } from "shared/components/Card";
import { IconButton, IconButtonSize } from "shared/components";
import { Copy01Icon, Delete01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { Widget } from "./widgets";
import { WidgetConfiguration } from "./widget-configuration";

export const QuestionsSlice = () => {
  const activeQuestion = useSurveyStore(selectActiveQuestion);
  const deleteQuestion = useSurveyStore((state) => state.deleteQuestion);
  const duplicateQuestion = useSurveyStore((state) => state.duplicateQuestion);

  return (
    <div className="flex animate-appear">
      <SidebarQuestions />

      <main className="bg-background-900 py-12 px-4">
        <div
          className="mx-auto flex gap-4  animate-appear max-w-[1000px] w-full"
          key={activeQuestion?.internal_id}
        >
          <Card className="w-[640px] flex flex-col min-h-[320px] shrink-0 p-6">
            <div className="flex-grow w-full">
              <Widget />
            </div>
            <footer className="mt-6 pt-6 border-t border-alpha-40 flex gap-2 justify-end">
              <IconButton
                size={IconButtonSize.SM}
                HugeIcon={Delete01Icon}
                onClick={deleteQuestion}
              />
              <IconButton
                size={IconButtonSize.SM}
                HugeIcon={Copy01Icon}
                onClick={duplicateQuestion}
              />
            </footer>
          </Card>
          <WidgetConfiguration />
        </div>
      </main>
    </div>
  );
};
